"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SponsoredCompetitionNotificationMetadataToJSON = exports.SponsoredCompetitionNotificationMetadataFromJSONTyped = exports.SponsoredCompetitionNotificationMetadataFromJSON = void 0;
var _1 = require("./");
function SponsoredCompetitionNotificationMetadataFromJSON(json) {
    return SponsoredCompetitionNotificationMetadataFromJSONTyped(json, false);
}
exports.SponsoredCompetitionNotificationMetadataFromJSON = SponsoredCompetitionNotificationMetadataFromJSON;
function SponsoredCompetitionNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'guildId': json['guildId'],
        'winningCriteria': (0, _1.WinningCriteriaFromJSON)(json['winningCriteria']),
    };
}
exports.SponsoredCompetitionNotificationMetadataFromJSONTyped = SponsoredCompetitionNotificationMetadataFromJSONTyped;
function SponsoredCompetitionNotificationMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'guildId': value.guildId,
        'winningCriteria': (0, _1.WinningCriteriaToJSON)(value.winningCriteria),
    };
}
exports.SponsoredCompetitionNotificationMetadataToJSON = SponsoredCompetitionNotificationMetadataToJSON;
